import React from 'react';

import styled from "styled-components"

import { Box, Typography } from "@material-ui/core"

export default styled(React.forwardRef(({
    title,
    className,
    children,
    id
}, ref) => {
    return (
        <div id={id} className={className}>
            {children}
        </div>
    )
}))`
&& {
    background: white;
    min-height: 100px;
    min-width: 100px;
    margin: 0 auto;
    height: ${({ height }) => height}px;
    width: ${({ width }) => width}px;
}
`